import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSpinnerOverlayComponent } from '../../components/mat-spinner-overlay/mat-spinner-overlay.component';
import { SnackBarService } from '../../services/snack-bar-service.service';
import { TipoAtualizacaoEnum } from '../rede-especial-enuns';
import { RedeEspecialService } from '../rede-especial.service';

@Component({
  selector: 'app-recusar-acordo-dialog',
  template: `
    <div class="dialog-container">
      <app-mat-spinner-overlay [overlay]="true" *ngIf="loading">
      </app-mat-spinner-overlay>

      <div class="dialog-header">
        <h2 mat-dialog-title>
          {{
            acordosSelecionados && acordosSelecionados.length > 1
              ? 'Recusar Acordos'
              : 'Recusar Acordo'
          }}
        </h2>
        <button
          mat-icon-button
          [mat-dialog-close]="false"
          class="close-button"
          matTooltip="Fechar diálogo"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="dialog-content">
        <div
          class="sumarizacao-acordos"
          *ngIf="acordosSelecionados && acordosSelecionados.length > 0"
        >
          <h4>Você está prestes a recusar o(s) seguinte(s) acordo(s):</h4>
          <ul>
            <li *ngFor="let acordo of acordosSelecionados">
              Acordo Nº:
              {{ acordo.codAcordo || acordo.codAep || acordo.codAdc }} Frota:
              {{ acordo.razaoSocialFrota }}
            </li>
          </ul>
        </div>
        <form [formGroup]="formRejeicao" class="mt-3">
          <mat-form-field appearance="outline" class="motivo-field w-100">
            <mat-label>Motivo da rejeição</mat-label>
            <textarea matInput formControlName="motivo" rows="4"></textarea>
            <mat-error *ngIf="formRejeicao.get('motivo')?.hasError('required')">
              O motivo do cancelamento é obrigatório.
            </mat-error>
          </mat-form-field>
        </form>
        <p
          *ngIf="acordosSelecionados && acordosSelecionados.length > 1"
          class="aviso-multiplos"
        >
          O mesmo motivo será aplicado para todos os
          {{ acordosSelecionados.length }} acordos selecionados.
        </p>
        <div class="row">
          <div class="col-12 text-end">
            <button mat-button class="btn-acao" (click)="onCancelar()">
              Voltar
            </button>
            <button
              mat-raised-button
              class="btn-acao btn-confirmar"
              [disabled]="
                !formRejeicao.valid ||
                !acordosSelecionados ||
                acordosSelecionados.length === 0
              "
              (click)="onConfirmar()"
            >
              Recusar
              {{
                acordosSelecionados && acordosSelecionados.length > 1
                  ? 'Acordos'
                  : 'Acordo'
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      ::ng-deep {
        .mat-dialog-container {
          padding: 0 !important;
        }
      }

      :host {
        .btn-acao {
          width: 200px;
          height: 56px;
          font-weight: bold;
          font-size: 16px;
          border-radius: 12px;
          border: 1px solid var(--cor-doc-pri-1);
          background-color: var(--cor-segunda);
          color: #fff;
        }

        .btn-confirmar {
          border: 1px solid var(--cor-doc-pri-3);
          background-color: var(--cor-doc-pri-3);
        }

        .dialog-container {
          display: flex;
          flex-direction: column;
          height: 100%;
          width: 100%;
          overflow: hidden;
          border-radius: var(--border-radius-sm);

          .dialog-header {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: nowrap;
            background-color: var(--cor-terceira) !important;
            color: var(--cor-fundo-tela);
            min-height: 50px;
            max-height: 50px;
            min-width: 100%;
            border-top-left-radius: var(--border-radius-sm);
            border-top-right-radius: var(--border-radius-sm);
            position: relative;
            padding: 8px;

            h2 {
              margin: 0;
              font-weight: 500;
              flex-grow: 1;
              color: var(--cor-fundo-tela) !important;
              margin-left: 2px;
              line-height: 1;
              display: flex;
              align-items: center;
            }

            .close-button {
              &:hover {
                background-color: rgba(255, 255, 255, 0.1);
                border-radius: var(--border-radius-sm);
                cursor: pointer;
              }
            }
          }
        }

        .dialog-content {
          padding: var(--spacing-md);
          background-color: #f5f5f5;
          overflow-y: auto;
          flex: 1;
          display: flex;
          flex-direction: column;
          position: relative;
        }

        .sumarizacao-acordos {
          margin-bottom: 24px;

          h4 {
            margin-bottom: 16px;
            font-size: 16px;
          }

          ul {
            list-style-type: disc;
            padding-left: 20px;
            margin-bottom: 16px;
          }

          li {
            margin-bottom: 8px;
            font-size: 14px;
          }
        }

        .text-end {
          text-align: right;
          padding: 16px;
          gap: 8px;

          button {
            margin-left: 8px;
          }
        }
      }
    `,
  ],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSpinnerOverlayComponent,
  ],
})
export class RecusarAcordoDialogComponent {
  formRejeicao: FormGroup;
  public loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private service: RedeEspecialService,
    private snackBar: SnackBarService,
    public dialogRef: MatDialogRef<RecusarAcordoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public acordosSelecionados: any
  ) {
    this.formRejeicao = this.fb.group({
      motivo: ['', Validators.required],
    });
  }

  onCancelar(): void {
    this.dialogRef.close(false);
  }

  onConfirmar(): void {
    this.loading = true;

    const selecionados = this.acordosSelecionados.map((acordo: any) => ({
      codAcordo: acordo.codAcordo,
      codAep: acordo.codAep,
      codSituacao: acordo.codSituacao,
      razaoSocialFrota: acordo.razaoSocialFrota,
    }));

    const payloadRejeitar = {
      listaAcordos: selecionados,
      dscUsuario: this.service.usuario.retorno.login,
      tipoAtualizacao: TipoAtualizacaoEnum.REJEICAO,
    };

    this.service.aprovarOuRejeitarAcordos(payloadRejeitar).subscribe({
      next: (res) => {
        this.snackBar.flashMessage(
          'Acordo(s) recusado(s) com sucesso!',
          ['snackbar-success'],
          'Fechar',
          2
        );
        this.dialogRef.close(true);
        this.loading = false;
      },
      error: (err) => {
        this.snackBar.flashMessage(
          'Erro ao recusar acordo(s)!',
          ['snackbar-error'],
          'Fechar',
          2
        );
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
